import { Box } from '@mui/material'
import CustomSwitch from './custom-switch'
import CustomDateInput from './custom-date-input'
import DatedRightGroup from './dated-right-group'

type RisikaAiProps = {
  enabled: boolean
  endDateValue: string | null
  label: string
  endDateLabel: string
  isLoading: boolean
  muted?: boolean
  onToggle: () => void
  onEndDateChange: (isoDate: string | null) => void
}

// ENG2-2614 — the Risika for AI toggle plus its end date, modelled on the
// Global Data toggle and its contract dates (global-data.tsx).
//
// The date is only shown while the toggle is on. Switching the toggle off
// hides the field and leaves the stored value alone: RisikaAPI owns the
// fill/clear rules (TRIAL_MCP sets today + 14, any other plan change clears
// it), CMD only shows and edits what is stored. An empty date means Risika for
// AI stays on until it is switched off by hand.
function RisikaAi({
  enabled,
  endDateValue,
  label,
  endDateLabel,
  isLoading,
  muted = false,
  onToggle,
  onEndDateChange,
}: RisikaAiProps) {
  return (
    // ENG2-2633: toggle + date read as one unit while the date is shown.
    <DatedRightGroup grouped={enabled}>
      <CustomSwitch
        isLoading={isLoading}
        onChange={onToggle}
        value={enabled}
        label={label}
        muted={muted}
      />
      {enabled && (
        // minWidth/flex mirror the Global Data date fields (ENG2-2395).
        <Box sx={{ minWidth: 160, flex: '0 0 auto', mt: 1 }}>
          <CustomDateInput
            value={endDateValue}
            label={endDateLabel}
            isLoading={isLoading}
            onChange={onEndDateChange}
            // A past end date would switch Risika for AI off on the spot;
            // blocking it here shows the problem in the field, not a failed PUT.
            disablePast
            helperText="Leave empty for no end date"
          />
        </Box>
      )}
    </DatedRightGroup>
  )
}

export default RisikaAi
